"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetLocationModal = void 0;
const React = require("react");
const react_1 = require("react");
const dialogs_1 = require("../../../../../types/dialogs");
const Modal_1 = require("../../../../../components/base/structure/Modal");
const Button_1 = require("../../../../../components/base/atoms/Button");
const AddressLookup_1 = require("../../../../../components/base/atoms/AddressLookup");
const geoCode_1 = require("../../../../../helpers/geoCode");
const CustomerGeolationLink_1 = require("../../atoms/CustomerGeolationLink");
const useConfig_1 = require("../../../../../hooks/useConfig");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const OrderTypeContext_1 = require("../../contexts/OrderTypeContext");
const TSalesOrderType_1 = require("../../types/TSalesOrderType");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "SetLocationModal");
const SetLocationModal = ({ open, setOpen, customerLocation, setCustomerLocation, clearRestaurantOnChange = false, onLocationChange }) => {
    const { googleApiKey } = (0, useConfig_1.useConfig)();
    const { orderType } = (0, useRequiredContext_1.useRequiredContext)(OrderTypeContext_1.OrderTypeContext);
    const { setRetailLocation, requestedRetailLocationSlug, setRequestedRetailLocationSlug } = (0, useRequiredContext_1.useRequiredContext)(RetailLocationsContext_1.RetailLocationsContext);
    const [updatedLocation, setUpdatedLocation] = (0, react_1.useState)(null);
    const [showClearSelectionModal, setShowClearSelectionModal] = (0, react_1.useState)(false);
    const header = (0, react_1.useMemo)(() => {
        return orderType === TSalesOrderType_1.TSalesOrderType.Pickup
            ? "Set current location"
            : "Set delivery address";
    }, [orderType]);
    const updateCustomerLocation = async (location) => {
        let success = true;
        if (typeof onLocationChange === "function") {
            success = await onLocationChange(location);
        }
        setShowClearSelectionModal(false);
        setOpen(false);
        if (!success) {
            return;
        }
        clearRestaurantOnChange && setRetailLocation(null);
        setCustomerLocation(location);
        setUpdatedLocation(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal_1.Modal, { onClose: !!customerLocation ? () => setOpen(false) : null, open: open, size: dialogs_1.TDialogSizes.Medium, showCloseIcon: !!customerLocation, closeOnOverlayClick: !!customerLocation, closeOnEsc: !!customerLocation },
            React.createElement(Modal_1.ModalHeader, null, header),
            React.createElement(Modal_1.ModalBody, null,
                React.createElement(AddressLookup_1.AddressLookup, { apiKey: googleApiKey, label: undefined, description: undefined, chosenAddress: async (place) => {
                        const locationDetails = (0, geoCode_1.formatLocationAddressFromGooglePlace)(place);
                        setUpdatedLocation(locationDetails);
                    } }),
                orderType === TSalesOrderType_1.TSalesOrderType.Pickup && (React.createElement("div", { className: css("") },
                    React.createElement(CustomerGeolationLink_1.CustomerGeolocationLink, { onGeolocated: updateCustomerLocation }))),
                React.createElement(Button_1.BlockButton, { disabled: !updatedLocation, onClick: () => {
                        requestedRetailLocationSlug
                            ? setShowClearSelectionModal(true)
                            : updateCustomerLocation(updatedLocation);
                    } }, "save"))),
        React.createElement(Modal_1.Modal, { open: showClearSelectionModal, onClose: () => {
                setShowClearSelectionModal(false);
            }, size: dialogs_1.TDialogSizes.Small, showCloseIcon: true, appMode: true },
            React.createElement(Modal_1.ModalBody, null, "Keep or clear the currently selected restaurant?"),
            React.createElement(Modal_1.ModalFooter, { onAccept: () => {
                    updateCustomerLocation(updatedLocation);
                }, acceptLabel: "Keep", onCancel: () => {
                    setRequestedRetailLocationSlug(null);
                    updateCustomerLocation(updatedLocation);
                }, cancelLabel: "Clear" }))));
};
exports.SetLocationModal = SetLocationModal;
//# sourceMappingURL=index.js.map